import React from "react";
import Experience from "../../sections/home1/Experience";
import MobileExperience from "../../sections/home1/MobileExperience";

const Demo  = ({ className, ...rest }) => {

  return (
    <>
    <div className={className} {...rest} style={{position: "relative", top:"-6px", zIndex:"100"}}> 
    <div className="container">
    <div className="row">
      <div className="col-12 text-center">
        <div className="d-none d-md-block">
          <Experience className="bg-digma-dark relative pt-14 pt-lg-18 pb-26 pb-lg-18" />
        </div> 
        <div className="d-block d-md-none"> 
          <MobileExperience className="bg-digma-dark relative pt-14 pt-lg-24 pb-26 pb-lg-30" />
        </div> 
      </div>
    </div>
  </div>
    </div>
  </>
  );
};

export default Demo;
